import React, { useMemo, memo } from 'react'
import { useDispatch } from 'react-redux'
import { updateSearchAction } from 'store/actions/header.action'
import Image from 'next/image'
import { VideoPlayer } from 'components/VideoTrimmerModal/components/VideoPlayer'
import { cn } from '@/lib/utils'

const ModelsList = memo(({ models, setSelectedAI, tags, mediaType, view }) => {
  const dispatch = useDispatch()

  const tempModels = useMemo(() => {
    return models?.map((item, i) => ({
      ...item,
      order: i,
    }))
  }, [models])

  const filteredModels = useMemo(() => {
    if (!tags || tags.length === 0) {
      return tempModels?.filter((item) => item.tags?.some((tag) => tag.toLowerCase().includes(mediaType)))
    }

    const tempFilterModels = tempModels?.filter((item) =>
      item.tags?.some((tag) => tags.toLowerCase().includes(tag.toLowerCase()))
    )
    if (tempFilterModels?.length) return tempFilterModels
    return tempModels?.filter((item) => item.tags?.some((tag) => tag.toLowerCase().includes(mediaType)))
  }, [tags, tempModels, mediaType])

  const handleModelClick = useMemo(
    () => (item) => {
      setSelectedAI({ ...item })
      dispatch(updateSearchAction(null))
    },
    [setSelectedAI, dispatch]
  )

  return (
    <div
      className={`gap-y-0 md:gap-y-1 gap-x-5 md:gap-x-3 grid grid-flow-col 
       md:grid-flow-row overflow-x-scroll md:overflow-x-hidden md:overflow-y-scroll
        md:h-[66vh]  2xl:h-[75vh]
        ${view === 'list' ? 'md:grid-cols-1' : 'md:grid-cols-2 grid-rows-2 md:grid-rows-none'}`}
    >
      {filteredModels?.map((item, i) => (
        <div
          key={item.id || i}
          className={`w-[140px] sm:w-full min-w-[140px] sm:min-w-0
            bg-white rounded-md border border-gray-200 hover:border-blue-500 hover:shadow-md transition-all  cursor-pointer flex
            ${view === 'list' ? 'flex-row items-center gap-2 ' : 'flex-col gap-1'}`}
          onClick={() => handleModelClick(item)}
        >
          {item?.color_icon && item.color_icon?.endsWith('.webm') ? (
            <div
              className={`${
                view === 'list' ? 'h-12 w-12 sm:h-[50px] sm:w-[50px]' : 'h-24 w-full sm:h-[120px] md:h-[198px]'
              }`}
            >
              <VideoPlayer
                src={item.color_icon}
                className={cn('h-full w-full object-cover', `${view !== 'list' ? ' rounded-t-md' : 'rounded-l-md'}`)}
              />
            </div>
          ) : (
            <div
              className={`relative ${
                view === 'list' ? 'h-12 w-12 sm:h-[50px] sm:w-[50px]' : 'h-24 w-full sm:h-[120px] md:h-[198px]'
              }`}
            >
              <Image
                src={item.image || item.color_icon}
                alt={item.name}
                fill
                className={cn('object-cover object-top', `${view !== 'list' ? ' rounded-t-md' : 'rounded-l-md'}`)}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                onError={(e) => {
                  e.target.onerror = null
                  e.target.src =
                    'https://st3.depositphotos.com/23594922/31822/v/450/depositphotos_318221368-stock-illustration-missing-picture-page-for-website.jpg'
                }}
              />
            </div>
          )}
          <div className="text-content pt-1 pb-3 px-3 flex-1">
            <h3 className="text-left font-semibold text-xs sm:text-sm whitespace-pre-wrap">{item.name}</h3>
            {view === 'list' && (
              <p className="text-[10px] sm:text-xs opacity-50 whitespace-pre-wrap line-clamp-2">{item.description}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  )
})

ModelsList.displayName = 'ModelsList'

export default ModelsList
